import {
  Component,
  Event, EventEmitter,
  Host, h,
  Listen,
  Prop
} from '@stencil/core'
import { KINDS, SIZES } from '@local/models'


@Component({
  tag: 'cr-button',
  styleUrl: 'cr-button.css',
  shadow: true,
})
export class CrButton {

  /**
   * Influences the visual emphasis of the button
   * @type string
   */
  @Prop() kind: KINDS | string = KINDS.TERTIARY

  /**
   * The button label
   * @type string
   */
  @Prop() label: string = ""

  /**
   * The size of the button, can be small (sm), medium (md) (default), large (lg), extra large (xl) and extra extra large (xxl)
   * @type string
   */
  @Prop() size: SIZES | string = SIZES.MEDIUM

  /**
   * Disables the button
   * @type boolean
   */
  @Prop() disabled: boolean = false

  /**
   * Emits internal button element's clock event beyond the shadow dom.
   * @type EventEmitter
   */
  @Event() formclick: EventEmitter<any>;


  @Listen('click')
  handleClickFocus(ev: MouseEvent) {
    ev.preventDefault()
    this.formclick.emit(ev)
  }

  render() {
    return (
      <Host>
        <button part="button" disabled={this.disabled} class={`button ${this.kind} ${this.size}`}>
          <div part="label" class={`label ${this.kind} ${this.size}`}>{this.label}</div>
          <div part="icon" class={`icon ${this.kind} ${this.size}`}><slot></slot></div>
        </button>
      </Host>
    )
  }

}
